<template>
  <div class="col-sm-12 col-md">
    <abstract-profile-text-input
      id="input-first_name"
      v-model="model"
      :error="errors"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import AbstractProfileTextInput from "../core/AbstractProfileTextInput";
import BaseInputMixin from "../../../../mixins/profileInputMixin";

export default {
  name: "FirstName",
  components: {AbstractProfileTextInput},
  mixins: [BaseInputMixin('first_name')],

  data() {
    return {
      defaultLabel: this.$t("First Name")
    }
  }
}
</script>

<style scoped>

</style>
